import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#121212] flex flex-col items-center justify-center p-4">
      <Logo />
      <h1 className="text-2xl font-bold text-white mt-8 mb-2">
        Page Not Found
      </h1>
      <p className="text-gray-400 text-center mb-8">
        The page you're looking for doesn't exist.
      </p>
      <Link
        to="/"
        className="py-3 px-6 bg-wobisch-blue text-white font-semibold rounded-xl hover:bg-wobisch-blue/90 transition-colors"
      >
        Go Home
      </Link>
    </div>
  );
}
